import React from 'react';
import { Breadcrumb, BreadcrumbItem } from 'reactstrap';
import Card from '../components/Cards/Cards';
import cardData from "../data/Carddata";
import { Row, Col } from "reactstrap";
import serviceImg from "../assets/pic2.jpg";

  const Services = (props) => {
    return (
        <div align="center">
            <h1 className="H1">Our Services</h1>
            <img src={serviceImg} className="serviceImage" alt="serviceImg"/>
            <div className="p-3">
                <Breadcrumb tag="nav" listTag="div">
                    <BreadcrumbItem tag="a" href="/">Home</BreadcrumbItem>
                    <BreadcrumbItem active tag="span">Services</BreadcrumbItem>
                </Breadcrumb>
            </div>
            <div className="serviceContent">
                <p>
                ThothIT is fulfilling the ever-changing IT demands, by providing the right resource, 
                at the right place and at the right time. We provide cost-effective, task-oriented IT 
                resources to our clients. We strongly believe in giving more than 100% and working 
                alongside the clients.
                </p>
            </div>
            <div className="container">
                    <Row>
                        {cardData.map((value, index)=>{
                            return (
                                <Col md={4}>
                                    <Card         
                                        key={value.id}        
                                        imgsrc={value.imgsrc}        
                                        title={value.title}       
                                        content={value.content}
                                        path={value.path}
                                        id={value.id}
                                    />  
                                </Col>
                            );
                        })}               
                    </Row>
                </div>
        </div>
        
    );
  };
  
  export default Services;